export default __webpack_public_path__ + "static/gamerize-5868d6f96fcaacd2c193d38b3dcd76e9.png";